import http from "../http-common";

class PersonaService {

    getPorRut(rut) {
        return http.get(`/personas/${rut}`);
    }

    getAll() {
        return http.get('/personas');
    }

    getCC() {
        return http.get('/personas/cc/get');
    }

    getById(id) {
        return http.get(`/personas/id/${id}`);
    }

    update(id, data) {
        return http.put(`/personas/${id}`, data);
    }

    getGerGen() {
        return http.get('/personas/gergen');
    }

    getPersonaByEstadoDesv(data) {
        return http.post('personas/personabyestadodesv', data);
    }
}

export default new PersonaService();